export const state = {
  fundingSourceTypes: [
    { text: 'Dollar Amount', value: 'dollar_amount' },
    { text: 'Staff Cost', value: 'staff_cost' },
    { text: 'Travel Cost', value: 'travel_cost' },
    { text: 'Percentage', value: 'percentage' },
  ],
};
